import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {ButtonTheme} from 'common/components/button/constants';

import type {QueryEntrySection} from '../index';

export function AddEntryRow({el}: {el: QueryEntrySection}) {
  const isDisabled = el.helpers.isAddingDisabled();
  const typeItems = el.helpers.getAddListTypeItems();
  const tooltipAttrs = el.helpers.getAddEntryButtonTooltipAttrs();
  const singleEntryType = typeItems.length === 1 && typeItems[0].value;

  const buttonContents = (
    <>
      {singleEntryType ? (
        <ButtonEl
          attrs={{
            disabled: isDisabled,
            theme: ButtonTheme.Tertiary,
            icon: `plus`,
            elref: `newEntryButton`,
            tooltip: !isDisabled && tooltipAttrs,
          }}
          class={{
            'is-open': el.state.isTypeSelectOpen,
          }}
          on={{
            click: () => el.addEntryRow(singleEntryType),
          }}
          hook={{
            insert: ({elm}) => el.helpers.onAutofocusableElAdded(elm),
          }}
        >
          <span>{el.attr(`add-entry-button-label`) || `Add`}</span>
        </ButtonEl>
      ) : (
        <SelectEl
          attrs={{
            elref: `typeSelect`,
            disabled: isDisabled,
            icon: {leftIcon: `plus`, rightIcon: ``},
            'selected-option': el.attr(`add-entry-button-label`) || `Add`,
            'menu-width': el.attr(`add-entry-menu-width`),
            sections: [{items: typeItems}],
            theme: SelectTheme.Tertiary,
            tooltip: !isDisabled ? tooltipAttrs : null,
          }}
          class={{
            'is-open': el.state.isTypeSelectOpen,
          }}
          on={{
            change: (ev: CustomEvent) => el.addEntryRow(ev.detail.item.value),
            menuChange: el.helpers.onAddTypeSelectMenuChange,
          }}
          hook={{
            insert: ({elm}) => el.helpers.onAutofocusableElAdded(elm),
          }}
        />
      )}
    </>
  );

  // contained sections (inside mp-section for instance) render as
  // another row whereas the new UI will render a button row
  if (el.hasNewQBUI() && !el.classList.contains(`contained-section`)) {
    return buttonContents;
  }

  return (
    <div
      sel='.mp-query-entry.is-add-row'
      key='new-entry'
      class={{
        'is-disabled': isDisabled,
        [`for-${singleEntryType}`]: Boolean(singleEntryType),
        'is-open': el.state.isTypeSelectOpen,
      }}
    >
      {/** include prefix spacing */}
      {el.state.prefixRenderer && <div sel='.entry-selector-prefix' />}
      {buttonContents}
    </div>
  );
}
